import { Component, OnInit, ViewChild } from '@angular/core';
import { lang_profile } from 'app/idiomas/i18n/profile/profile.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ProfileService} from './profile.service';
import { AuthService } from 'app/auth/auth.service';
import * as backInter from 'app/auth/auth-data.model';
import { MatSnackBar } from "@angular/material/snack-bar";
import Swal from 'sweetalert2';
import {TranslateService} from '@ngx-translate/core';
import { MatInput } from '@angular/material/input';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent  {
  myForm: FormGroup;
  passwordForm: FormGroup;
  mostrarSeccion:boolean=false;
  m1_check:boolean;
  show:boolean=true;
  profile:boolean;
  seccionProfile:boolean=false;
  charChinos = '\u2E80-\u2FD5\u3400-\u4DBF\u4E00-\u9FCC';
  charTurcos = '\u011F\u011E\u0131\u0130\u00F6\u00D6\u00FC\u00DC\u015F\u015E\u00E7\u00C7';
  charIdiomas = this.charChinos + this.charTurcos;
  regexEmail = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?\.)+[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?$");
  @ViewChild('idPassword', { read: MatInput }) input: MatInput;
  @ViewChild('idPassword2', { read: MatInput }) input2: MatInput;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    public fb: FormBuilder,
    public profileservice: ProfileService,
    private _snackBar: MatSnackBar,
    public authService: AuthService,
    private translateSrv: TranslateService,
  ) {
    lang_profile.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.getInfoEmpresa();
   }
  hide = true;
  hide2 = true;
  password: string = "";
  ngOnInit() {

    this.m1_check=false;
    this.myForm = this.fb.group({
      //name: ['', [Validators.required]],
      email: ['', [Validators.required]]
    });
    this.passwordForm = this.fb.group({
      password1: ['', [Validators.required]],
      password2: ['', [Validators.required]]
    });
    setTimeout(() => {
      this.input.value = '';
      this.input2.value = '';
    }, 800);


  }
  Useremail:any;
  datosEmp:any;
  nombreEmpresa:any;
  instituto:any;
  empresaId:any;
  codeverify:any;
  users:any[]=[];
  idUser:any;
  levelUser:any;
  bloquearBtnCodigo:boolean=true;
  sendCode:boolean=false;
  check_code:boolean=false;
  btnChangePassword:boolean=true;
  getInfoEmpresa(){
    let idEmpresa: string;
    this.profileservice.getInfoEmpresa().subscribe((data:backInter.infoEmpresa) => {
        this.datosEmp = data;
        console.log(this.datosEmp);
        if(this.datosEmp.message = "Success"){
          this.nombreEmpresa = this.datosEmp.data.nombreEmpresa;
          this.instituto = this.datosEmp.data.institutoEmpresa;
          this.getUser();
        }
      }, error  => {
        console.log("error get info empresa");
      });
  }

  getUser(){
    let datosUsu = this.authService.getInfoUsuario();
    this.Useremail=datosUsu.user;
    this.empresaId = datosUsu.empresaId;
    this.levelUser=datosUsu.level;
    this.obtenerUsuarios();
  }

  obtenerUsuarios(){
    this.profileservice.getUsuariosEmpresas(this.empresaId, this.instituto).subscribe((data:backInter.infoEmpresa) => {
      this.datosEmp = data;
      console.log(this.datosEmp);
      this.users=(this.datosEmp.usuarios);
      for(let i=0; i < this.users.length; i++){
        if(this.users[i].user==this.Useremail){
          this.idUser=this.users[i]._id;
          console.log(this.idUser);
        }
      }
    }, error  => {
      console.log("error get info empresa");
    });
  }
  password1: string = "";
  password2: string = "";
  bloquearInfo:boolean=true;
  checkData(){
    if(this.myForm.valid){
      let dato = this.myForm.get('email').value;
      let pasadato = this.regexEmail.test(dato);
      if(pasadato){
        let emailDato = this.myForm.get('email').value;
        //let nombre=this.myForm.get('name').value;

         console.log("Son iguales nombres");
          if(emailDato == this.Useremail){
            console.log("Son iguales, se puede cambiar");
            //this.myForm.controls['name'].disable();
            this.myForm.controls['email'].disable();
            this.sendCode=false; // Como es igual el correo no necesita código
            this.check_code=true;
          }else{ //Como no esa igual debe enviar pin de 4 dígitos
            this.bloquearBtnCodigo=false;
          }
        /*}else{
          this.Error_openSnackBar(this.translateSrv.instant('PROFILE.ERROR.ERROR07'),this.translateSrv.instant('PROFILE.SUCCESS.OK') );
        }*/

      }else{ //No es dato email

      }
    }
  }
  keyVerify:any;
  cerrarSesion:boolean=false;
  enviarVerificacion(){
    this.cerrarSesion=true;
    let idiomaNavegador = navigator.language.split("-");
    console.log("idiomaNavegador",idiomaNavegador);

    let idiomaCGO: string;
    let dato = this.myForm.get('email').value;
    //let name =this.myForm.get('name').value;
    let datos={
      user: dato,
      //nameUser:name,
      language: idiomaNavegador[0],
      brokerId: localStorage.getItem('instituto_id')
    }
    console.log(datos);
    Swal.showLoading();
    this.profileservice.enviarCodigo(datos,this.idUser).subscribe((response:any) => {
      console.log(response);
      Swal.close();
        if(response.success){
          this.Success_openSnackBar(this.translateSrv.instant('PROFILE.SUCCESS.MESESAGE2'),this.translateSrv.instant('PROFILE.SUCCESS.OK') );
          this.keyVerify=response.keyVerify;
          this.sendCode=true;
          //this.myForm.controls['name'].disable();
          this.myForm.controls['email'].disable();
        }else if(!response.response){
          this.Error_openSnackBar(this.translateSrv.instant('PROFILE.ERROR.ERROR06'),this.translateSrv.instant('PROFILE.SUCCESS.OK') );
        }
      }, error => {
        //console.log(error);
        if(error.error.success == false){
          console.log("Nel perro");
        }

    });
  }
  showSecond_pass:boolean=false;
  checkfirts(){
    let pass1 = this.passwordForm.get('password1').value;
    if(pass1.length >= 3){
      this.showSecond_pass=true;
    }else{
      this.Error_openSnackBar(this.translateSrv.instant('PROFILE.ERROR.ERROR02'),this.translateSrv.instant('PROFILE.SUCCESS.OK') );
    }
  }
  newPassword:any;
  checkPassword(){
    if(this.passwordForm.valid){
      let pass1 = this.passwordForm.get('password1').value;
      let pass2 = this.passwordForm.get('password2').value;
      if(pass1 == pass2){
        this.newPassword=pass1;
        this.btnChangePassword=false;
        console.log("La contraseñas son iguales, se puede avanzar");
      }else{
        this.Error_openSnackBar(this.translateSrv.instant('PROFILE.ERROR.ERROR04'),this.translateSrv.instant('PROFILE.SUCCESS.OK') );
        this.btnChangePassword=true;

      }
    }
  }

  actualizarDatos(){
    this.btnChangePassword=true;
    console.log("Id user "+ this.idUser);
    let datos={
      level:this.levelUser,
      institutoId:this.instituto,
      user:this.Useremail,
      password:this.newPassword,
      empresaId:localStorage.getItem('companyID'),
    }
    console.log('datos antes de actualizar',datos);

    Swal.showLoading();
    this.profileservice.actualizaUsuariosEmpresas( this.idUser,datos).subscribe((response:any) => {
      this.hide=!this.hide;
      this.hide2=!this.hide2;
      this.btnChangePassword=false;
      this.myForm.reset();
      this.passwordForm.reset();
      Swal.close();
        if(response.message=="200"){
          console.log("Se puede");
          this.check_code=false;
          this.sendCode=false;
          this.Success_openSnackBar(this.translateSrv.instant('PROFILE.SUCCESS.MESESAGE1'),this.translateSrv.instant('PROFILE.SUCCESS.OK') );
          if(this.cerrarSesion){
            setTimeout( () => {
              this.authService.logout();
              this.cerrarSesion=false;
              console.log("se ejecutaron en segundo plano ");
            },2000);
          }
        }else if(response.message=="userAlreadyExist"){
          console.log("Email registrado");
          this.Error_openSnackBar(this.translateSrv.instant('PROFILE.ERROR.ERROR02'),this.translateSrv.instant('PROFILE.SUCCESS.OK') );
        }
      }, error => {
        //console.log(error);
    });
  }

  obtenerMenu(opcion){
    switch(opcion){
      case 1:
        this.seccionProfile=true;
      break;
    }
  }


  checkCode(){
    if(this.codeverify==this.keyVerify){
      this.Success_openSnackBar(this.translateSrv.instant('PROFILE.SUCCESS.MESESAGE3'),this.translateSrv.instant('PROFILE.SUCCESS.OK') );
      this.check_code=true;
      this.Useremail = this.myForm.get('email').value;
    }else{
      this.Error_openSnackBar(this.translateSrv.instant('PROFILE.ERROR.ERROR03'),this.translateSrv.instant('PROFILE.SUCCESS.OK') );
      console.log("Código no verificado");
    }

  }

  Success_openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3500,
      verticalPosition: 'bottom',
      panelClass: ['background-success']
    });
  }

  Error_openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom',
      panelClass: ['background-red']
    });
  }


}
